import { Link } from "react-router-dom";
import { Lock, ShieldCheck, KeyRound, ServerCog } from "lucide-react";
import { useApp } from "@/lib/i18n";

const METHODS = [["stripe", "Stripe"], ["paypal", "PayPal"], ["visa", "Visa"], ["mastercard", "Mastercard"], ["americanexpress", "American Express"], ["applepay", "Apple Pay"], ["googlepay", "Google Pay"]];

const BADGES = [["pdpa", ShieldCheck, ["Patuh PDPA", "PDPA compliant"], "/privacy"], ["encrypted", KeyRound, ["Data disulitkan", "Encrypted data"]], ["ssl", ServerCog, ["Pelayan selamat SSL", "SSL-secured servers"]]];

const TrustBadges = ({ id }) => {
  const { L } = useApp();
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={`trust-badges-${id}`}>
      {BADGES.map(([key, Icon, label, to]) => {
        const cls = "flex h-9 items-center gap-1.5 rounded-lg border border-emerald-200 bg-emerald-50 px-3 text-xs font-semibold text-emerald-800 transition-[transform,background-color] duration-200 hover:-translate-y-0.5";
        const body = <><Icon size={15} className="text-emerald-600" />{L(...label)}</>;
        return to
          ? <Link key={key} to={to} className={`${cls} hover:bg-emerald-100`} data-testid={`trust-badge-${id}-${key}`}>{body}</Link>
          : <span key={key} className={cls} data-testid={`trust-badge-${id}-${key}`}>{body}</span>;
      })}
    </div>
  );
};

export const PaymentMethods = ({ compact = false, id = "pricing" }) => {
  const { L } = useApp();
  return (
    <div className={`flex flex-wrap items-center gap-3 ${compact ? "" : "justify-center"}`} data-testid={`payment-methods-${id}`}>
      <span className="flex items-center gap-1.5 text-xs font-medium text-slate-500">
        <Lock size={14} className="text-emerald-600" />{L("Pembayaran selamat melalui", "Secure payments via")}
      </span>
      <div className="flex flex-wrap items-center gap-2">
        {METHODS.map(([key, name]) => (
          <span key={key} title={name} className="grid h-9 w-14 place-items-center rounded-lg border border-slate-200 bg-white shadow-sm transition-transform duration-200 hover:-translate-y-0.5" data-testid={`payment-icon-${id}-${key}`}>
            <img src={`/brand/pay/${key}.svg`} alt={name} className={["visa", "applepay", "googlepay", "americanexpress"].includes(key) ? "h-8 w-10 object-contain" : "h-5 w-auto max-w-[40px]"} />
          </span>
        ))}
      </div>
      <span className="hidden h-6 w-px bg-slate-300 lg:block" />
      <TrustBadges id={id} />
    </div>
  );
};
